import { api } from '../utils/api';

const createCancellation = (url, params, onSuccess, onFail) =>
  api({ format: 'javascript' }).delete(`${url}`, { data: params })
    .then(onSuccess)
    .catch(onFail);

export {
  createCancellation,
};